import styled from 'styled-components'
import React from 'react'
import Main from './Main'

const NotFound = () => {
  return <Wrapper />
}

export default NotFound

const Wrapper = styled(Main)`
  min-height: 100%;
`
